import { types } from "../action-types";

// import initialState from './appReducer';
const initialState = {
  loading: false,
  // skills: [],
  timesheet_list: [],
  error: {},
};

const initialStateforDetails = {
  approveTimeSheetLoading: false,
  loading: false,
  timesheetDetails: [],
  timeSheetApprovalSuccess: false,
  error: {},
}

const initialStateforGraph = {
  loading: false,
  details: [],
  error: {},
}

const TimesheetListReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_TIMESHEET_LIST_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case types.GET_TIMESHEET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        timesheet_list: action.payload,
        error: false,
      }
    case types.GET_TIMESHEET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        matched: [],
        error: true,
      }
    default:
      return state;
  }
};

export const TimesheetDetailsReducer = (state = initialStateforDetails, action) => {
  switch (action.type) {
    case types.GET_TIMESHEET_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case types.GET_TIMESHEET_SUCCESS:
      return {
        ...state,
        loading: false,
        timesheetDetails: action.payload,
        error: false,
      }
    case types.GET_TIMESHEET_FAILURE:
      return {
        ...state,
        loading: false,
        timesheetDetails: [],
        error: true,
      }

    // Timesheet Approval Cases
    case types.APPROVE_TIMESHEET_REQUESTED:
      return {
        ...state,
        approveTimeSheetLoading: true,
        timeSheetApprovalSuccess: false
      }
    case types.APPROVE_TIMESHEET_SUCCESS:
      return {
        ...state,
        approveTimeSheetLoading: false,
        timesheetApprovedResponse: action.payload,
        timeSheetApprovalSuccess: true,
        error: false,
      }
    case types.APPROVE_TIMESHEET_FAILURE:
      return {
        ...state,
        approveTimeSheetLoading: false,
        timesheetApprovedResponse: [],
        timeSheetApprovalSuccess: false,
        error: true,
      }

    default:
      return state;
  }
};

export const timesheetGraphReducer = (state = initialStateforGraph, action) => {
  switch (action.type) {
    case types.GET_GRAPH_DETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case types.GET_GRAPH_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        details: action.payload,
        error: false,
      }
    case types.GET_GRAPH_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        details: [],
        error: true,
      }
    default:
      return state;
  }
};

export default TimesheetListReducer;
